export function LightLoader({ text = "Sincronizzazione..." }: { text?: string }) {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-canvas/80 backdrop-blur-xl z-[9999]">
      <div className="relative flex items-center justify-center mb-8 w-16 h-16">
        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-purple-600 animate-spin" style={{ animationDuration: '2s' }} />
        <div className="absolute inset-1 rounded-full border-2 border-transparent border-b-emerald-500 animate-spin" style={{ animationDuration: '1.5s', animationDirection: 'reverse' }} />
        <div className="absolute flex items-center justify-center z-10">
          <img
            src={`${import.meta.env.BASE_URL}jarvis-icon-48.png`}
            alt="Jarvis Logo"
            width="28"
            height="28"
            className="rounded opacity-80"
          />
        </div>
      </div>
      <div className="text-sm font-extrabold text-text-secondary uppercase tracking-[0.2em]">
        <span className="opacity-40">{text}</span>
      </div>
    </div>
  );
}